import { getTrack } from '../mocks/tracking'
import GlobalState from './GlobalState'
import { observable, runInAction } from 'mobx'

const ContentState: any = observable({
  tracking: null,
  localeMenu: null,
  imgs: null,
})
export const getTrackingContent = async () => {
  try {
    const lang = GlobalState.currentLocale.lang

    runInAction(() => {
      ContentState.tracking = getTrack(lang)
    })
  } catch (e) {
    console.log(e)
  }
}

export const getLocaleMenu = async () => {
  try {
    const fd = new FormData()
    fd.append('lang', GlobalState.currentLocale.lang)
    fd.append('status', 'locale-menu')
    const request = await fetch(
      'https://personal.novaposhtaglobal.ua/' + 'post-react',
      {
        method: 'POST',
        body: fd,
      },
    )
    const response = await request.json()

    runInAction(() => {
      ContentState.localeMenu = response
    })
  } catch (e) {
    console.log(e)
  }
}

export const getBanners = async () => {
  try {
    const fd = new FormData()
    fd.append('lang', GlobalState.currentLocale.lang)
    fd.append('status', 'banners')
    const request = await fetch('https://personal.novaposhtaglobal.ua/' + 'post-react', {
      method: 'POST',
      body: fd,
    })
    const response = await request.json()

    runInAction(() => {
      ContentState.track = response
    })
  } catch (e) {
    console.log(e)
  }
}

export default ContentState
